import React from 'react';
import styled from 'styled-components';
import parseUnderscores from '../../lib/parse-underscores';

const Heading = styled.h2`
  font-family: ${p => p.theme.sansSerif};
  line-height: 1.5em;
  font-size: 24px;
  text-align: center;
  color: #666;
  font-weight: 700;
  margin-bottom: 2em;
`;

const Translation = styled.h3`
  font-family: ${p => p.theme.serif};
  font-style: italic;
  line-height: 1.5em;
  font-size: 18px;
  text-align: center;
  color: #666;
  font-weight: 700;
  margin-top: -2em;
  margin-bottom: 2em;
`;

const ChapterTitle = ({ title, translation }) => {
  return (
    <>
      <Heading>{title}</Heading>
      {translation && <Translation {...parseUnderscores(translation)} />}
    </>
  );
};

export default ChapterTitle;
